export default __webpack_public_path__ + "static/media/bhilwara.8b519efa.jpeg";